/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ContactPerson as ContactPersonModel } from 'models';
import Fade from 'react-reveal/Fade';
import { inject, observer } from 'mobx-react';
import { FADE_VALUES } from 'animations/Animations';
import styled from 'styled-components';
import ds from 'designsystem';
import { safeHtmlWithBr } from 'common/methods/string';
import ContactPersonWrapper from './ContactPersonWrapper';
import ContactLink from './ContactLink';
import LinksWrapper from './LinksWrapper';
import ImageColumn from './ImageColumn';
import PersonImage from './PersonImage';
import PersonName from './PersonName';
import PersonDescription from './PersonDescription';
import ContactDataWrapper from './ContactDataWrapper';
import ContactData from './ContactData';
import TextColumn from './TextColumn';

const Link = styled.a`
  color: ${ds.brand('text')};
  text-decoration: none;
  font-size: ${ds.fs('m')};
`;

@inject('windowStore')
@observer
export default class ContactPerson extends Component {
  renderLinks() {
    const {
      data: {
        links,
      },
    } = this.props;

    return (
      <LinksWrapper>
        {links.map(link => (
          <ContactLink
            data={link}
            key={link.id}
          />
        ))}
      </LinksWrapper>
    );
  }

  render() {
    const {
      data: {
        email,
        phone,
        photo,
        description,
        name,
      },
      index,
      windowStore,
    } = this.props;

    return (
      <Fade
        bottom
        distance={`${FADE_VALUES.BOX.SMALL}`}
        delay={index * FADE_VALUES.DELAY.SMALL}
      >
        <ContactPersonWrapper>

          <ImageColumn>
            <PersonImage
              src={windowStore.adjustImageSize(photo)}
            />
            { !windowStore.isOnMobile ? this.renderLinks() : null }
          </ImageColumn>

          <TextColumn>
            <PersonName
              dangerouslySetInnerHTML={{
                __html: safeHtmlWithBr(name),
              }}
            />

            <PersonDescription
              dangerouslySetInnerHTML={{
                __html: safeHtmlWithBr(description),
              }}
            />

            <ContactDataWrapper>
              <ContactData>
                <Link
                  href={`tel: ${phone.match(/\+|\d/g).join('')}`}
                  dangerouslySetInnerHTML={{
                    __html: safeHtmlWithBr(phone),
                  }}
                />
              </ContactData>
              <ContactData underline>
                <Link
                  href={`mailto: ${email}`}
                  dangerouslySetInnerHTML={{
                    __html: safeHtmlWithBr(email),
                  }}
                />
              </ContactData>
            </ContactDataWrapper>

            { windowStore.isOnMobile && this.renderLinks() }
          </TextColumn>

        </ContactPersonWrapper>
      </Fade>
    );
  }
}

ContactPerson.propTypes = {
  data: PropTypes.instanceOf(ContactPersonModel).isRequired,
  index: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/kentico-blocks/CallUs/ContactPerson/index.jsx